import Alan from '../../assets/Alan-Wintermeyer.webp'
import Matthew from '../../assets/Matthew-Burns.jpg'
import Reeze from '../../assets/reeze-telling.webp'

export const teamMembers = [
    {
      name: 'Alan Wintermeyer',
      role: 'Field Hockey Coach',
      bio: 'With over 15 years of coaching experience, Alan leads our field hockey program with passion and expertise.',
      specialties: ['Youth Development', 'Advanced Techniques'],
      image: Alan
    },
    {
      name: 'Reeze Telling',
      role: 'Cricket Coach',
      bio: 'Former professional player turned coach, Reeze brings international experience to our cricket training programs.',
      specialties: ['Batting Technique', 'Match Strategy'],
      image: Reeze
    },
    {
      name: 'Matthew Burns',
      role: 'Baseball Coach',
      bio: 'NCAA Division I experience and a knack for developing young talent make Matthew a cornerstone of our baseball program.',
      specialties: ['Pitching', 'Batting Mechanics'],
      image: Matthew
    }
  ];

// Testimonials section data
export const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Parent",
    quote:
      "The Bat Cage has transformed my son's confidence and skills. The coaches truly care about each athlete's development.",
  },
  {
    name: "David Chen",
    role: "High School Athlete",
    quote:
      "Training here has improved my game tremendously. The facilities are amazing and the coaches provide personalized attention.",
  },
];
